export default __webpack_public_path__ + "19th_border.059b619.jpeg";